
const Script = {
    intro : [
        // {
        //     text: "Weather in Melbourne on the 5th of December, twenty twenty.\n",
        //     sound: null,
        //     pauseAfter: 2
        // },
        {
            text: "Temperature is represented like a Geiger Counter, with more ticks for higher temperatures. For example, 10 degrees.",
            sound: "/sounds/ticks_10_c.wav"
        },
        {
            text: "and 20 degrees.",
            sound: "/sounds/ticks_20_c.wav",
            pauseAfter: 1
        },
        {
            text: "Wind strength is represented by the volume of the wind sound. For example, 10 kilometres per hour.",
            sound: "/sounds/wind.wav",
            volume: 0.2

        },
        {
            text: "25 kilometres per hour.",
            sound: "/sounds/wind.wav",
            volume: 0.5
        },
        {
            text: "and 50 kilometres per hour.",
            sound: "/sounds/wind.wav",
            volume: 1,
            pauseAfter: 1
        },
        {
            text: "The wind sound moves according to the wind's source direction. Westerly wind's are on the left hand side.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: -1
        },
        {
            text: "Easterly wind's are on the right hand side.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: 1,
            pauseAfter: 1
        },
        {
            text: "Northerly wind's are in front.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: 0,
        },
        {
            text: "Southerly wind's are behind.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: 0,
            lowPass: 600,
            pauseAfter: 1
        },
        {
            text: "Wind's can be heard in all directions, including the south east.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: 0.3,
            lowPass: 600,
        },
        {
            text: "The north east.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: 0.3,
        },
        {
            text: "The south west.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: -0.3,
            lowPass: 600,
        },
        {
            text: "And the north west.",
            sound: "/sounds/wind.wav",
            volume: 1,
            balance: -0.3,
            pauseAfter: 1
        },
        {
            text: "A rain sound is heard when the chance of rain is above 25%. It increases in intensity for the amount of rain expected. For example, 0.1 millimetres",
            sound: "/sounds/light_rain.wav"
        },
        {
            text: "1 millimetre",
            sound: "/sounds/medium_rain.wav"
        },
        {
            text: "and 2 millimetres",
            sound: "/sounds/heavy_rain.wav",
            pauseAfter: 1
        },
        {
            text: "Time will be indicated with every third hour being announced.",
            pauseAfter: 1
        },
        {
            text: "We now begin our sonification of the weather, starting at midnight.",
            sound: null,
            pauseAfter: 2
        }
    ]
}

export default Script;